<script>
  import TwoColumns from "../TwoColumns.svelte";
  import SchedulePanel from "../../blocks/schedule-panel/SchedulePanel.svelte";
  import type { ISchedulePanel } from "../../blocks/schedule-panel/SchedulePanel.svelte";
  import type { IPageData } from "../../../core/types";
  import FolderStructure from "./folder-structure/FolderStructure.svelte";
  import { t } from "../../../core";
  import Input from "../../elements/Input.svelte";

  interface IDocumentsPage extends IPageData {
    teaser: string;
    schedulePanel: ISchedulePanel;
  }

  export let data: IDocumentsPage;

  let searchVal: string;
  let foldersStructureRef: FolderStructure;

	let timer: number;
  const debouncedSearchUpdate = (e: any) => {
		clearTimeout(timer);

    const v = e.target.value;
		timer = setTimeout(() => {
			searchVal = v;
      console.log('here')
      foldersStructureRef?.getFolder(null, searchVal)
		}, 300);
	}
</script>

<TwoColumns>
  <div class="g-centered">
    <h1 class="title">{data.title}</h1>
    <div class="teaser rte">{@html data?.teaser}</div>

    <section class="document-list">
      <div class="document-list-top">
        <div class="document-list-top__title">{t("Page.DocLib.ListTitle")}</div>

        <Input
          type="text"
          class="document-list-top__search g-input"
          placeholder={t("General.Search.Title")}
          bind:value={searchVal}
          on:keyup={debouncedSearchUpdate}
        />
      </div>

      <FolderStructure bind:this={foldersStructureRef} on:clearSearch={() => searchVal = ''} />
    </section>
  </div>

  <slot />

  <div slot="aside">
    <SchedulePanel schedulePanel={data.schedulePanel} />
  </div>
</TwoColumns>

<style lang="scss">
  .title {
    @include h1;
    margin-bottom: 20px;
  }

  .teaser {
    @include normal;
    margin-bottom: 40px;
  }

  .document-list {
    margin-bottom: 40px;

    &-top {
      display: flex;
      gap: 10px;
      flex-direction: column;
      margin-bottom: 10px;

      @include sm {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
      }

      &__title {
        @include h2;
        margin-bottom: 0;
      }
    }

    :global(.base-input-label) {
      margin-bottom: 0;
    }

    :global(.document-list-top__search) {
      border-color: $separator-color;

      @include sm {
        width: 250px;
      }
    }
  }
</style>
